





























import { Vue, Component, Prop } from 'vue-property-decorator';
import { EButtonType, EModalSize } from '@getaccept/lib-ui';
import { IRecipient } from '@lib-shared/types/Recipient';
import { IDocument } from '@lib-shared/types/Document';
import { IIntegration } from '@signing-page/integrations/types/integration';

@Component({
  data: () => ({
    EButtonType,
    EModalSize,
  }),
})
export default class AuthorizeNet extends Vue {
  @Prop() recipient!: IRecipient;
  @Prop() document!: IDocument;
  @Prop() integration!: IIntegration;
  @Prop() authId!: string;

  loading = false;

  get shouldRender(): boolean {
    if (this.integration === undefined) {
      return false;
    }
    return true;
  }

  get title(): string {
    return this.$t('pay-with-authorize-dot-net').toString();
  }

  get externalUrl(): string {
    if (typeof this.integration.externalUrl === undefined) {
      return '';
    }
    if (!this.integration.externalUrl) {
      return `/auth/authorizenet/${this.document.id}/${this.recipient.id}/${this.authId}`;
    }
    return this.integration.externalUrl;
  }

  handleClose() {
    this.$emit('close');
  }
}
